/* ELEMENT — CART UPSELL. Binds in connectedCallback so the card survives
   Prestige's Section Rendering refresh of the drawer. */
(function () {
  'use strict';
  if (customElements.get('element-upsell')) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var MONEY = function (pence) { return '£' + (pence / 100).toFixed(2); };

  var emit = function (name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true }));
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      var payload = { event: name };
      for (var k in detail) { if (Object.prototype.hasOwnProperty.call(detail, k)) payload[k] = detail[k]; }
      window.dataLayer.push(payload);
    }
  };

  class ElementUpsell extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-el-upsell-add]');
      this.label = this.querySelector('[data-el-upsell-label]');
      this.errorEl = this.querySelector('[data-el-upsell-error]');
      this.rule = this.dataset.rule;
      this.variantId = this.dataset.variantId;
      this.expectedPrice = parseInt(this.dataset.expectedPrice, 10);
      this.handle = this.dataset.productHandle;
      if (!this.button || !this.variantId) return;
      this.onClick = this.onClick.bind(this);
      this.button.addEventListener('click', this.onClick);
      emit('element:offer_shown', { rule: this.rule, variant_id: this.variantId, product_handle: this.handle, offer_price: this.expectedPrice });
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.onClick);
    }

    setBusy(isBusy) {
      this.button.disabled = isBusy;
      if (this.label) this.label.textContent = isBusy ? 'Adding' : 'Add';
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message;
      this.errorEl.hidden = false;
    }

    onClick() {
      var self = this;
      if (this.button.disabled) return;
      this.setBusy(true);
      if (this.errorEl) this.errorEl.hidden = true;

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(this.variantId), quantity: 1, properties: { _element_offer: this.rule } }] })
      })
      .then(function (res) {
        if (!res.ok) { return res.json().then(function (e) { throw new Error(e.description || e.message || 'Could not add that just now.'); }); }
        return res.json();
      })
      .then(function () { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        self.verifyPrice(cart);
        emit('element:offer_added', { rule: self.rule, variant_id: self.variantId, product_handle: self.handle, cart_total_after: cart.total_price });
        self.refreshCart(cart);
      })
      .catch(function (e) {
        self.setBusy(false);
        self.showError((e && e.message) || 'Something went wrong. Please try again.');
        emit('element:offer_failed', { rule: self.rule, reason: String(e && e.message) });
      });
    }

    /* The discount comes from Shopify's automatic Buy X Get Y, not from Liquid.
       If it did not fire, the customer must be told here — not at checkout. */
    verifyPrice(cart) {
      var self = this;
      var line = null;
      (cart.items || []).forEach(function (item) {
        if (!line && String(item.variant_id) === String(self.variantId) && item.properties && item.properties._element_offer === self.rule) line = item;
      });
      if (!line) return;
      var actual = Math.round(line.final_line_price / line.quantity);
      if (actual !== this.expectedPrice) {
        this.showError('Added at ' + MONEY(actual) + ' rather than ' + MONEY(this.expectedPrice) + '. The offer did not apply — remove it if that is not what you wanted.');
        emit('element:offer_price_mismatch', { rule: this.rule, variant_id: this.variantId, expected: this.expectedPrice, actual: actual });
      }
    }

    refreshCart(cart) {
      var self = this;
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'element-upsell', cart: cart }); } catch (e) {}
      }
      // Guarantee the customer sees the updated cart.
      setTimeout(function () { if (self.isConnected) window.location.reload(); }, 1200);
    }
  }

  customElements.define('element-upsell', ElementUpsell);

  /* Free delivery bar: add a progress track, and hide it when the threshold is
     out of reach. At £35, a £14.99 cart is £20.01 away — that is a closed door. */
  function enhanceBar() {
    var bar = document.querySelector('free-shipping-bar');
    if (!bar || bar.getAttribute('data-el-enhanced') === 'true') return;
    var threshold = parseFloat(bar.getAttribute('threshold')) * 100;
    var total = parseFloat(bar.getAttribute('total-price'));
    if (!threshold || isNaN(total)) return;

    var MIN_VISIBLE = 1999;
    if (total < MIN_VISIBLE) { bar.setAttribute('data-el-hidden', 'true'); return; }
    bar.setAttribute('data-el-hidden', 'false');

    var pct = Math.max(0, Math.min(100, (total / threshold) * 100));
    var track = document.createElement('div');
    track.className = 'el-fdbar__track';
    var fill = document.createElement('div');
    fill.className = 'el-fdbar__fill';
    fill.style.width = pct + '%';
    track.appendChild(fill);
    bar.appendChild(track);
    bar.setAttribute('data-el-enhanced', 'true');
    if (total >= threshold) emit('element:bar_cleared', { cart_total: total, threshold: threshold });
  }

  document.addEventListener('DOMContentLoaded', enhanceBar);
  document.addEventListener('cart:refresh', function () { setTimeout(enhanceBar, 0); });
  document.documentElement.addEventListener('cart:refresh', function () { setTimeout(enhanceBar, 0); });
  setTimeout(enhanceBar, 400);
})();
